import { useMutation, useQueryClient } from "@tanstack/react-query";
import { proveedorApi } from "@/features/proveedor/services/proveedor.api";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";

/**
 * Mutation para asignar el proveedor de un RFC emisor. Hidrata la
 * solicitud actualizada en el cache para que el stepper de la pantalla
 * siguiente se pinte correctamente sin esperar al refetch, y dispara
 * una invalidación de los grupos para refrescar el checkmark visual.
 */
export function useSeleccionarProveedorPorRfc(
  solicitudId: string,
  rfcEmisor: string
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (numeroProveedor: number) =>
      proveedorApi.seleccionarPorRfc(solicitudId, rfcEmisor, numeroProveedor),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      qc.invalidateQueries({ queryKey: qk.proveedoresAgrupados(solicitudId) });
      toastExito({ title: "Proveedor asignado", message: `RFC ${rfcEmisor}` });
    },
    onError: toastErrorApi,
  });
}
